import ComingSoon from "@/components/custom/coming-soon";
const CollectionPage = () => <ComingSoon label="Collection" />;
export default CollectionPage;